import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { StudyAreaStatus } from '../../enums/study-area-status';
import { takeUntil, Subject } from 'rxjs';

@Component({
  selector: 'app-study-area-paid-modal',
  templateUrl: './study-area-paid-modal.component.html',
  styleUrls: ['./study-area-paid-modal.component.scss'],
})
export class StudyAreaPaidModalComponent implements OnInit, OnDestroy {
  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig
  ) {}

  ngOnInit() {
    this.model = { ...this.config.data };
    this.projectDirectoryLinkClicked$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(() => {
        window.open(
          'https://apex.stantec.com/apex/r/ibautil/project-directory/project-directory',
          '_blank',
          'noopener'
        );
      });
  }

  private ngUnsubscribe = new Subject<void>();
  private projectDirectoryLinkClicked$ = new Subject<{
    field: FormlyFieldConfig;
    event: Event;
  }>();

  form: FormGroup = new FormGroup({});
  model: {
    projectCode?: string;
    invoiceId?: string;
    currentStatus?: StudyAreaStatus;
  } = {};
  prjCodeFields: FormlyFieldConfig[] = [
    {
      className: 'basin-width-100',
      key: 'projectCode',
      id: 'projectCode',
      type: 'textbox',
      props: {
        label: 'Project Code',
        type: 'string',
        required: true,
        description:
          "To access Oracle information via Stantec's Project Directory, click here.",
        actionDescription: true,
        actionDescriptionClicked: this.projectDirectoryLinkClicked$,
      },
    },
  ];
  invoiceIdFields: FormlyFieldConfig[] = [
    {
      className: 'basin-width-100',
      key: 'invoiceId',
      id: 'invoiceId',
      type: 'textbox',
      props: {
        label: 'Invoice ID',
        type: 'string',
        required: false,
      },
    },
  ];

  cancel() {
    this.ref.close();
  }

  accept(model: { projectCode?: string; invoiceId?: string }) {
    this.ref.close(model);
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
